<adapt-dashboard-element name="Activity relevant to me">
    <adapt-personal-activity-feed [person]="person$ | async"></adapt-personal-activity-feed>
</adapt-dashboard-element>
